module.exports = __webpack_public_path__ + "app/img/logo-viber.f1e11a13.svg";